var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefunded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25993",
    "data-name": "Group 25993",
    transform: "translate(-48 -272)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(48 272)",
    fill: "#f63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25992",
    "data-name": "Group 25992",
    transform: "translate(0.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25991",
    "data-name": "Group 25991",
    transform: "translate(57.295 281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37453",
    "data-name": "Path 37453",
    d: "M441.389,228.9a6.584,6.584,0,1,1,.948,5.313.557.557,0,0,1,.921-.628h0a5.467,5.467,0,1,0-.791-4.406",
    transform: "translate(-440.998 -223.518)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37454",
    "data-name": "Path 37454",
    d: "M446.711,236.4a6.989,6.989,0,0,1-5.771-3.049.961.961,0,0,1,1.586-1.083,5.064,5.064,0,1,0-.733-4.081l-.783-.194a5.873,5.873,0,1,1,.85,4.73.154.154,0,0,0-.255.174,6.182,6.182,0,1,0-.889-4.988l-.782-.2a6.987,6.987,0,1,1,6.777,8.687Z",
    transform: "translate(-439.934 -222.42)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37455",
    "data-name": "Path 37455",
    d: "M437,230.808a.942.942,0,0,1-.86-.71l-1-3.959a.941.941,0,0,1,1.825-.459l.766,3.046,3.047-.766a.941.941,0,0,1,.458,1.825l-3.959.995A.939.939,0,0,1,437,230.808Z",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, -332.883, -15.972)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefunded);
export default __webpack_public_path__ + "static/media/refunded.e5199f2342c39c55d9dc633373033050.svg";
export { ForwardRef as ReactComponent };